import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';
import { PdpDesktopStoneSpecTable } from './PdpDesktopStoneSpecTable';
import type { GemstoneLine, StoneSpecification } from '@/features/pdp/utils/productDetailStones';

interface PdpDesktopGemstoneDetailsProps {
  gem?: GemstoneLine;
  specs?: StoneSpecification[];
}

export function PdpDesktopGemstoneDetails({ gem, specs }: PdpDesktopGemstoneDetailsProps) {
  if (specs && specs.length > 0) {
    return <PdpDesktopStoneSpecTable specs={specs} hideSizeRow />;
  }

  if (!gem) return null;

  return (
    <>
      {gem.count != null ? <PdpDesktopDetailRow label="Count" value={gem.count} /> : null}
      <PdpDesktopDetailRow label="Stone Type" value={gem.type} />
    </>
  );
}
